module.exports = __webpack_public_path__ + "static/media/ladies-group.01cf541f.png";